<template>
  <div>
    <NavBar />
    <ExamScoreTable
      :exam="exam"
      @deleteScore="refetch"
      @saved="refetch"
    />
  </div>
</template>
  
<script setup>
import NavBar from "../components/NavBar.vue";
import ExamScoreTable from "../components/ExamScoreTable.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";
import { GET_EXAM } from "../graphql/queries";
import { useQuery } from "@vue/apollo-composable";

const route = useRoute();
const exam_id = parseInt(route.params.exam_id);

const { result, refetch } = useQuery(GET_EXAM, { exam_id });

// Computed scores data
const exam = computed(() => result.value?.exam || {});

</script>